interface ServiceHeaderProps {
	title: string;
	frequency?: string;
	location?: string;
	price: string;
	duration: string;
	isPOA?: boolean;
	requiresConsultation?: boolean;
	consultationPrice?: string;
}

export function ServiceHeader({
	title,
	frequency,
	location,
	price,
	duration,

	isPOA,
	requiresConsultation,
	consultationPrice,
}: ServiceHeaderProps) {
	return (
		<header className='flex flex-wrap gap-10 justify-between items-start pb-6 w-full border-b border-neutral-800 border-opacity-20 max-md:max-w-full'>
			<div className='flex flex-col min-w-60 w-[314px]'>
				<h1 className='text-2xl font-semibold'>{title}</h1>
				<div className='flex gap-2 items-start self-start mt-4 text-xs font-bold leading-tight uppercase flex-wrap'>
					<span className='whitespace-nowrap rounded-sm border border-solid border-neutral-800'>
						<span className='gap-2 self-stretch p-2'>{frequency}</span>
					</span>
					<span className='rounded-sm border border-solid border-neutral-800'>
						<span className='gap-2 self-stretch p-2'>{location}</span>
					</span>
					<span className='rounded-sm border border-solid border-neutral-800'>
						<span className='gap-2 self-stretch p-2'>{duration}</span>
					</span>
				</div>
			</div>
			{!isPOA && (
				<div className='w-[198px]'>
					<p className='text-base font-bold leading-none'>PRICE</p>
					{requiresConsultation ? (
						<>
							<p className='mt-4 text-2xl font-black leading-none'>
								From R{price}
							</p>
							{consultationPrice && (
								<p className='mt-2 font-semibold text-md leading-5'>
									Initial consultation Fee: R{consultationPrice}
								</p>
							)}
						</>
					) : (
						<p className='mt-4 text-4xl font-black leading-none'>R{price}</p>
					)}
				</div>
			)}
		</header>
	);
}
